<template>
  <el-dialog
    :visible.sync="visible"
    :close-on-click-modal="false"
    title="修改密码"
    width="400px">
    <div class="pwd-wp">
      <p class="mb-10 mt-0">
        <i class="el-icon-warning"></i>
        密码不少于8位，需包含数字、大小写字母和特殊字符
      </p>
      <form>
        <div class="input-wrap psw-input-box">
          <input
            class="box-input psw-input"
            :type="findPswKeyOn ? 'text' : 'password'"
            placeholder="请输入新密码"
            v-model="form.newPsw"
            @keyup.enter="commit"
            @keydown="clearErrorTip"
          />
          <span
            class="psw-icon"
            :class="findPswKeyOn ? 'on' : 'off'"
            @click="findPswKeyOn = !findPswKeyOn"
          ></span>
        </div>
        <div class="input-wrap psw-input-box">
          <input
            class="box-input psw-input"
            :type="findAgainPswKeyOn ? 'text' : 'password'"
            placeholder="请再次输入新密码"
            v-model="form.checkNewPwd"
            @keyup.enter="commit"
            @keydown="clearErrorTip"
          />
          <span
            class="psw-icon"
            :class="findAgainPswKeyOn ? 'on' : 'off'"
            @click="findAgainPswKeyOn = !findAgainPswKeyOn"
          ></span>
        </div>
        <div class="psw-check">
          <p>
            <span class="err-msg" v-if="forgetTip"
              ><i class="el-icon-warning"></i>{{ forgetTip }}</span
            >
          </p>
        </div>
      </form>
    </div>
    <div class="msg-fd">
      <el-button @click="close" type="text">取消</el-button>
      <el-button @click="commit" :disabled="!form.newPsw || !form.checkNewPwd" type="primary" style="margin-left: 30px;" size="medium">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  data() {
    return {
      findPswKeyOn: false,
      findAgainPswKeyOn: false,
      forgetTip: '',
      form: {
        newPsw: "",
        checkNewPwd: "",
      }
    }
  },
  computed: {
    ...mapState({
      pwdDialog: state => state.pwdDialog
    }),
    visible: {
      get() {
        const { pwdDialog } = this

        return pwdDialog
      },
      set(val) {
        this.SETPWDDIALOG(val)
      }
    },
  },
  methods: {
    ...mapMutations(['SETPWDDIALOG', 'SETMSGDIALOG']),
    close() {
      this.SETPWDDIALOG(false)
      this.SETMSGDIALOG(null)
      this.form = {
        newPsw: "",
        checkNewPwd: "",
      }
      this.clearErrorTip()
    },
    /**,
     * 清除错误信息
     */
    clearErrorTip() {
      this.forgetTip = "";
    },
    async commit() {
      const { form } = this

      if (!form.newPsw || !form.checkNewPwd) return

      if (!/^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[#?!@$%^&*-]).{8,}$/.test(form.newPsw)) {
          this.forgetTip = "密码不少于8位，需包含数字、大小写字母和特殊字符"
          return
      }
      if (form.newPsw !== form.checkNewPwd) {
          this.forgetTip = "两次密码需一致"
          return
      }

      try {
        await this.$api.system.edit({
          password: form.newPsw,
          editType: 1
        })

        this.SETMSGDIALOG({
          title: '提示',
          message: '修改密码成功，点击确认重新登陆',
          hideClose: true,
          commit: () => {
            localStorage.removeItem('t')
            localStorage.removeItem('prefix')
            this.close()
            window.location.href = '/login'
          }
        })
      } catch(err) {
        console.info(err)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  ::v-deep .msg-fd {
    text-align: right;
    padding-top: 30px;
    .el-button--primary.is-disabled {
      background-color: rgba(47, 116, 255, 0.2);
      border: unset;
    }
  }
  .pwd-wp {
    .input-wrap {
      position: relative;
      margin-bottom: 20px;
      display: flex;
      align-items: center;

      &.psw-input-box {
        margin-bottom: 20px;
      }

      .psw-icon {
        width: 20px;
        height: 20px;
        display: inline-block;
        position: absolute;
        background-repeat: no-repeat;
        background-size: 100%;
        right: 0;
        @include pointer;
        &.on {
          background-image: url('./image/login_icon_key_on.png');
        }
        &.off {
          background-image: url('./image/login_icon_key_off.png');
        }
      }
    }

    .box-input {
      width: 100%;
      @include line-height(53px, 53px);
      outline: unset;
      appearance: unset;
      background: #ffffff;
      border-bottom: 1px solid #d0d0d0;
      font-size: 16px;

      &:focus {
        border-color: $main-color;
      }

      &.psw-input {
        padding-right: 50px;
      }

      &.error-input {
        border: 1px solid rgba(246, 104, 46, 1);
      }
    }
    .psw-check {
      position: relative;
      font-size: 14px;
      line-height: 20px;
      height: 20px;
      display: flex;
      align-items: center;
      p {
        padding-right: 60px;
        color: $warn-color;
      }

      .el-icon-warning {
        font-size: 16px;
        color: $warn-color;
        margin-right: 6px;
      }
    }
  }
</style>
